package data.search_data

import models.SearchData

// Search suggestions (78)
val MachuPicchuSearchSuggestions = listOf(
    "hat",
    "figure",
    "earflare",
    "prosopis",
    "fiber",
    "ornament",
    "paccha",
    "copper",
    "feline",
    "bronze",
    "canopa",
    "figurine",
    "costumes",
    "dish",
    "tomb",
    "lime",
    "miniature",
    "top",
    "bottle",
    "wood",
    "gilded",
    "inlay",
    "tumi",
    "alloy",
    "silver",
    "pin",
    "slip",
    "resin",
    "warrior",
    "woven",
    "tupu",
    "gold",
    "implements",
    "stirrup",
    "tunic",
    "votive",
    "jar",
    "camelid",
    "stone",
    "sculpture",
    "spoon",
    "cornered",
    "knife",
    "sheet",
    "ceramics",
    "turquoise",
    "ornaments",
    "pigment",
    "metal",
    "profile",
    "post",
    "head",
    "spout",
    "pigmented",
    "sling",
    "cast",
    "ceramic",
    "cotton",
    "shell",
    "hammered",
    "containers",
    "kero",
    "bird",
    "double",
    "escallonia",
    "textiles",
    "ceremonial",
    "hair",
    "bag",
    "staff",
    "tapestry",
    "vessel",
    "funerary",
    "feathers",
    "paint",
    "disk",
    "fragment",
    "container"
)

// Machu Picchu (366)
val MachuPicchuSearchData = listOf(
    SearchData(
        1400,
        310616,
        "Double Vessel, Monkey",
        "vessel|silver|metal-containers",
        "ao/mobile-large/DT10189.jpg",
        0.78
    ),
    SearchData(
        600,
        318644,
        "Profile Warrior Ornament",
        "ornament|gilded copper, shell, turquoise|metal-ornaments",
        "ao/mobile-large/1987.394.72.JPG",
        0.82
    ),
    SearchData(
        1500,
        313275,
        "Vessel",
        "bottle|ceramic|ceramics-containers",
        "ao/mobile-large/vs1979_206_1082.jpg",
        0.84
    ),
    SearchData(
        1500,
        315620,
        "Copper Pin",
        "pin|silver (hammered)|metal-ornaments",
        "ao/mobile-large/vs1987_394_560.jpg",
        0.39
    ),
    SearchData(
        750,
        316963,
        "Four-Cornered Hat",
        "hat|camelid hair|textiles-costumes",
        "ao/mobile-large/HZ1994_35_138.jpg",
        1.11
    ),
    SearchData(
        1500,
        315624,
        "Ornamented Knife",
        "knife|copper|metal-implements",
        "ao/mobile-large/hz1987_394_564.jpg",
        1.15
    ),
    SearchData(
        1500,
        313287,
        "Storage Jar (aryballos)",
        "bottle|ceramic, pigment|ceramics-containers",
        "ao/mobile-large/vs1979_206_1094.jpg",
        0.88
    ),
    SearchData(
        1650,
        316847,
        "Kero",
        "kero|wood, metal inlay, red pigment|wood-containers",
        "ao/mobile-large/1994.35.19_a.JPG",
        0.78
    ),
    SearchData(
        1385,
        312796,
        "Hanging",
        "hanging|cotton|textiles-woven",
        "ao/mobile-large/DT9943.jpg",
        0.76
    ),
    SearchData(
        1500,
        315228,
        "Bronze Mace Head in Feline Form",
        "mace head|bronze (cast)|metal-implements",
        "ao/mobile-large/1987.394.166_a.jpg",
        1.47
    ),
    SearchData(
        1500,
        315283,
        "Pin",
        "pin|copper, gilt|metal-ornaments",
        "ao/mobile-large/vs1987_394_223A.JPG",
        0.36
    ),
    SearchData(
        1500,
        313222,
        "Ceremonial Implement",
        "implement|wood, resin paint, metal|wood-implements",
        "ao/mobile-large/DP-23805-001.jpg",
        0.39
    ),
    SearchData(
        1400,
        315609,
        "Pin",
        "pin|silver (hammered)|metal-ornaments",
        "ao/mobile-large/DP216738.jpg",
        0.64
    ),
    SearchData(
        1500,
        315490,
        "Copper Tumi with Figure",
        "knife|copper (cast)|metal-implements",
        "ao/mobile-large/vs1987_394_415.jpg",
        0.78
    ),
    SearchData(
        1400,
        315608,
        "Pin",
        "pin|silver (hammered)|metal-ornaments",
        "ao/mobile-large/DP216737.jpg",
        0.65
    ),
    SearchData(
        1475,
        313341,
        "Double bowl",
        "bowl|ceramic, slip|ceramics-containers",
        "ao/mobile-large/DP-24356-001.jpg",
        1.33
    ),
    SearchData(
        1500,
        313152,
        "Tunic",
        "tunic|camelid hair|textiles-woven",
        "ao/mobile-large/DP244273.jpg",
        1.33
    ),
    SearchData(
        1500,
        313205,
        "Dish with Bird Head",
        "dish|ceramic, pigment|ceramics-containers",
        "ao/mobile-large/1979.206.1008.jpg",
        1.55
    ),
    SearchData(
        1500,
        315285,
        "Copper Pin",
        "pin|copper, gilt|metal-ornaments",
        "ao/mobile-large/vs1987_394_225.JPG",
        0.42
    ),
    SearchData(
        750,
        316970,
        "Four-Cornered Hat",
        "hat|camelid hair|textiles-costumes",
        "ao/mobile-large/HZ1994_35_145.jpg",
        1.08
    ),
    SearchData(
        1500,
        314528,
        "Tunic with Diamond Band",
        "tunic|camelid hair, cotton|textiles-woven",
        "ao/mobile-large/DP107698.jpg",
        0.90
    ),
    SearchData(
        500,
        314681,
        "Prisoner jar",
        "jar|ceramic, slip|ceramics-containers",
        "ao/mobile-large/DP-24362-001.jpg",
        0.75
    ),
    SearchData(
        1140,
        309105,
        "Tupu (pin)",
        "pin|copper|metal-ornaments",
        "ao/mobile-large/hz64_228_607.jpg",
        0.36
    ),
    SearchData(
        1466,
        317753,
        "Female figurine",
        "figure|silver-gold alloy|sculpture-sheet metal",
        "ao/mobile-large/DP-13440-036.jpg",
        0.67
    ),
    SearchData(
        550,
        309427,
        "Ear Ornament, Winged Runner",
        "earflare|gold, turquoise, sodalite, shell|metal-ornaments",
        "ao/mobile-large/66.196.40.jpg",
        0.77
    ),
    SearchData(
        825,
        307975,
        "Tunic with Confronting Catfish",
        "tunic|camelid hair, tapestry-weave|textiles-woven",
        "ao/mobile-large/DT829.jpg",
        1.98
    ),
    SearchData(
        1350,
        307467,
        "Tweezers",
        "tweezers|silver|metal-implements",
        "ao/mobile-large/82.1.23.JPG",
        0.93
    ),
    SearchData(
        400,
        309411,
        "Headdress Ornament",
        "headdress ornament|gold|metal-ornaments",
        "ao/mobile-large/DP-14786-039.jpg",
        1.34
    ),
    SearchData(
        1500,
        313225,
        "Funerary Staff",
        "tomb post|wood, silver, nails|wood-sculpture",
        "ao/mobile-large/DP-23803-001.jpg",
        0.42
    ),
    SearchData(
        1500,
        315618,
        "Silver Pin",
        "pin|silver (hammered)|metal-ornaments",
        "ao/mobile-large/vs1987_394_558.JPG",
        0.77
    ),
    SearchData(
        1500,
        313226,
        "Funerary Staff",
        "staff|wood, paint, metal sheathing|wood-sculpture",
        "ao/mobile-large/DP-23808-001.jpg",
        0.33
    ),
    SearchData(
        750,
        308121,
        "Four-Cornered Hat",
        "hat|camelid hair, cotton|textiles-woven",
        "ao/mobile-large/DP264889.jpg",
        0.75
    ),
    SearchData(
        750,
        316962,
        "Four-Cornered Hat",
        "hat|camelid hair|textiles-costumes",
        "ao/mobile-large/hz1994_35_137.jpg",
        1.17
    ),
    SearchData(
        1300,
        310476,
        "Feathered Tabard",
        "tunic|cotton, feathers|feathers-costumes",
        "ao/mobile-large/DP218937.jpg",
        1.33
    ),
    SearchData(
        750,
        316339,
        "Four-Cornered Hat",
        "hat|camelid hair|textiles-costumes",
        "ao/mobile-large/HZ1994_35_149.jpg",
        1.03
    ),
    SearchData(
        1500,
        307941,
        "Bag Tassel",
        "bag fragment|camelid hair, cotton|textiles-woven",
        "ao/mobile-large/DP18687_28.171.4,1.jpg",
        0.60
    ),
    SearchData(
        1650,
        316841,
        "Kero",
        "kero|wood (escallonia), pigmented resin inlay|wood-containers",
        "ao/mobile-large/DP104798.jpg",
        1.00
    ),
    SearchData(
        1466,
        309227,
        "Tupu (pin)",
        "pin|copper alloy|metal-ornaments",
        "ao/mobile-large/vs64_228_701.jpg",
        0.48
    ),
    SearchData(
        750,
        316980,
        "Four-Cornered Hat",
        "hat|camelid hair|textiles-costumes",
        "ao/mobile-large/HZ1994_35_160.jpg",
        1.09
    ),
    SearchData(
        1500,
        313269,
        "Deer Stick",
        "staff|wood, paint|wood-sculpture",
        "ao/mobile-large/1979.206.1076.jpg",
        1.50
    ),
    SearchData(
        750,
        312911,
        "Four-Cornered Hat",
        "hat|camelid hair, cotton|textiles-costumes",
        "ao/mobile-large/1979.206.724 a.jpg",
        0.99
    ),
    SearchData(
        1650,
        316846,
        "Kero",
        "kero|wood, tin inlay|wood-containers",
        "ao/mobile-large/DP-24246-001.jpg",
        0.86
    ),
    SearchData(
        1500,
        313271,
        "Headband",
        "head ornament|gold (hammered)|metal-ornaments",
        "ao/mobile-large/vs1979_206_1078.jpg",
        0.16
    ),
    SearchData(
        1500,
        313206,
        "Dish with Bird Head",
        "dish|ceramic, pigment|ceramics-containers",
        "ao/mobile-large/1979.206.1009.jpg",
        1.50
    ),
    SearchData(
        1466,
        313251,
        "Female figurine",
        "figure|gold|sculpture-sheet metal",
        "ao/mobile-large/DP-13440-033.jpg",
        0.70
    ),
    SearchData(
        1500,
        315286,
        "Ceremonial Knife (Tumi)",
        "knife|copper (cast)|metal-implements",
        "ao/mobile-large/vs1987_394_226.jpg",
        1.00
    ),
    SearchData(
        1500,
        315227,
        "Ceremonial Knife (Tumi)",
        "knife|bronze (cast)|metal-implements",
        "ao/mobile-large/1987.394.165_a.jpg",
        1.36
    ),
    SearchData(
        1700,
        316855,
        "Kero",
        "kero|wood, pigmented resin inlay|wood-containers",
        "ao/mobile-large/DP104805.jpg",
        0.95
    ),
    SearchData(
        550,
        308526,
        "Stirrup Spout Bottle with Bird and Snake",
        "bottle|ceramic, slip|ceramics-containers",
        "ao/mobile-large/64.228.20.JPG",
        0.75
    ),
    SearchData(
        550,
        308508,
        "Owl Warrior Bottle",
        "bottle|ceramic|ceramics-containers",
        "ao/mobile-large/64.228.2.JPG",
        0.67
    ),
    SearchData(
        750,
        316973,
        "Four-Cornered Hat",
        "hat|camelid hair|textiles-costumes",
        "ao/mobile-large/HZ1994_35_148.jpg",
        1.07
    ),
    SearchData(
        -250,
        307617,
        "Bowl",
        "bowl|ceramic, post-fired paint|ceramics-containers",
        "ao/mobile-large/63.232.73_b.jpg",
        1.36
    ),
    SearchData(
        400,
        308535,
        "Figure Jar",
        "jar|ceramic, slip|ceramics-containers",
        "ao/mobile-large/64.228.29_a.JPG",
        0.67
    ),
    SearchData(
        1475,
        309389,
        "Storage Jar (Aryballus)",
        "bottle|ceramic|ceramics-containers",
        "ao/mobile-large/66.30.6_a.jpg",
        0.80
    ),
    SearchData(
        1500,
        317591,
        "Votive Container (Canopa)",
        "vessel|stone|stone-containers",
        "ao/mobile-large/1994.35.758.jpg",
        1.50
    ),
    SearchData(
        1600,
        316843,
        "Kero",
        "kero|wood, pigmented resin inlay|wood-containers",
        "ao/mobile-large/hz1994_35_15.jpg",
        0.71
    ),
    SearchData(
        -1000,
        310662,
        "Feline-shaped stirrup-spout bottle",
        "bottle|ceramic|ceramics-containers",
        "ao/mobile-large/DP-24349-001.jpg",
        0.75
    ),
    SearchData(
        325,
        309145,
        "Chisel or tupu (pin)",
        "pin|copper|metal-implements",
        "ao/mobile-large/vs64_228_619.jpg",
        0.31
    ),
    SearchData(
        1600,
        316845,
        "Kero",
        "kero|wood (prosopis?), pigmented resin inlay|wood-containers",
        "ao/mobile-large/hz1994_35_17.jpg",
        0.80
    ),
    SearchData(
        1250,
        316723,
        "Serpent (tunjo)",
        "figure|gold|metal-ornaments",
        "ao/mobile-large/vs1992_92_1.jpg",
        0.30
    ),
    SearchData(
        1500,
        312635,
        "Bronze Tumi with Figures",
        "knife|bronze|metal-implements",
        "ao/mobile-large/1979.206.415.JPG",
        0.67
    ),
    SearchData(
        750,
        316965,
        "Four-Cornered Hat",
        "hat|camelid hair|textiles-costumes",
        "ao/mobile-large/HZ1994_35_140.jpg",
        1.12
    ),
    SearchData(
        1466,
        315606,
        "Tupu (pin)",
        "pin|copper alloy|metal-ornaments",
        "ao/mobile-large/vs1987_394_546.JPG",
        0.64
    ),
    SearchData(
        1450,
        314615,
        "Woven Sling Shot",
        "sling shot|camelid hair|textiles-woven",
        "ao/mobile-large/250581.jpg",
        2.65
    ),
    SearchData(
        600,
        315161,
        "Disk Ornament",
        "ornament|gilded copper|metal-ornaments",
        "ao/mobile-large/1987.394.99.JPG",
        1.24
    ),
    SearchData(
        1500,
        315290,
        "Knife (Tumi)",
        "knife|copper (cast)|metal-implements",
        "ao/mobile-large/1987.394.230_a.jpg",
        0.92
    ),
    SearchData(
        1475,
        315486,
        "Ornamented Knife (tumi)",
        "knife|tin bronze|metal-implements",
        "ao/mobile-large/DP108299.jpg",
        1.03
    ),
    SearchData(
        -250,
        308498,
        "Bowl",
        "bowl|ceramic, post-fired paint|ceramics-containers",
        "ao/mobile-large/63.232.95a.jpg",
        1.61
    ),
    SearchData(
        800,
        309104,
        "Tupu (pin)",
        "pin|copper and gold|metal-ornaments",
        "ao/mobile-large/hz64_228_606.jpg",
        0.37
    ),
    SearchData(
        1499,
        308287,
        "Feathered Tabard",
        "tabard|cotton, feathers|feathers-costumes",
        "ao/mobile-large/DP216335.jpg",
        0.83
    ),
    SearchData(
        1500,
        315249,
        "Copper Lime Spoon with Bird Top",
        "lime spoon|copper (cast)|metal-implements",
        "ao/mobile-large/VS1987_394_188.JPG",
        0.50
    ),
    SearchData(
        -50,
        310550,
        "Bottle, Trophy-Head",
        "bottle|ceramic|ceramics-containers",
        "ao/mobile-large/vs1978_412_98.jpg",
        0.77
    ),
    SearchData(
        600,
        315147,
        "Profile Warrior Ornament",
        "ornament|gilded copper, shell|metal-ornaments",
        "ao/mobile-large/1987.394.85.JPG",
        0.84
    ),
    SearchData(
        600,
        315119,
        "Disk with Owl",
        "ornament|gilded copper, silvered copper, shell, beads, fibers, organic pseudomorphs|metal-ornaments",
        "ao/mobile-large/AOA49.jpg",
        0.95
    ),
    SearchData(
        1700,
        316850,
        "Kero",
        "kero|wood, tin studs, and pigmented resin inlays|wood-containers",
        "ao/mobile-large/hz1994_35_22.jpg",
        0.72
    ),
    SearchData(
        1500,
        315333,
        "Copper Lime Spoon with Feline Top",
        "lime spoon|copper (cast)|metal-implements",
        "ao/mobile-large/VS1987_394_288.JPG",
        0.45
    ),
    SearchData(
        1500,
        315265,
        "Copper Lime Spoon",
        "lime spoon|copper (cast)|metal-implements",
        "ao/mobile-large/vs1987_394_205a.jpg",
        0.78
    ),
    SearchData(
        650,
        308408,
        "Bottle with fox head",
        "bottle|ceramic, slip|ceramics-containers",
        "ao/mobile-large/DP-23624-001.jpg",
        0.98
    ),
    SearchData(
        1250,
        309540,
        "Figure Pendant",
        "pendant|gold|metal-ornaments",
        "ao/mobile-large/DP-17780-001.jpg",
        1.33
    ),
    SearchData(
        1420,
        316939,
        "Miniature Tunic",
        "miniature tunic|cotton, camelid hair|textiles-woven",
        "ao/mobile-large/DP-13440-003.jpg",
        1.27
    ),
    SearchData(
        1475,
        309396,
        "Miniature Jar with Two Handles",
        "jar|ceramic|ceramics-containers",
        "ao/mobile-large/66.30.13.jpg",
        1.05
    ),
    SearchData(
        1500,
        315622,
        "Silver Pin",
        "pin|silver (hammered), gold|metal-ornaments",
        "ao/mobile-large/VS1987_394_562.JPG",
        0.27
    ),
    SearchData(
        1400,
        310205,
        "Bottle, Anthropomorphic Crab",
        "bottle|ceramic, slip|ceramics-containers",
        "ao/mobile-large/1976.287.14.JPG",
        0.67
    ),
    SearchData(
        750,
        316964,
        "Four-Cornered Hat",
        "hat|camelid hair|textiles-costumes",
        "ao/mobile-large/HZ1994_35_139.jpg",
        1.24
    ),
    SearchData(
        1300,
        698331,
        "Pair of Earflares with Multifigure Scenes",
        "earflare|gold|metal-ornaments",
        "ao/mobile-large/DP370838.jpg",
        1.82
    ),
    SearchData(
        500,
        308415,
        "Architectural Vessel",
        "vessel|ceramic|ceramics-containers",
        "ao/mobile-large/DP-23896-001.jpg",
        0.65
    ),
    SearchData(
        1500,
        315303,
        "Lime Spoon, Bird",
        "lime spoon|silver (hammered)|metal-implements",
        "ao/mobile-large/VS1987_394_243.JPG",
        0.45
    ),
    SearchData(
        1700,
        316849,
        "Kero",
        "kero|wood (prosopis?)|wood-containers",
        "ao/mobile-large/hz1994_35_21.jpg",
        0.81
    ),
    SearchData(
        1700,
        698427,
        "Pair of Keros with Carved Feline Handles",
        "kero|wood, pigmented resin inlays|wood-containers",
        "ao/mobile-large/DP104803.jpg",
        1.16
    ),
    SearchData(
        1600,
        318145,
        "Tunic",
        "tunic|camelid hair|textiles-woven",
        "ao/mobile-large/DP137345.jpg",
        1.99
    ),
    SearchData(
        1450,
        309753,
        "Stirrup Spout Bottle with Fish",
        "bottle|ceramic|ceramics-containers",
        "ao/mobile-large/1970.245.38.jpg",
        0.67
    ),
    SearchData(
        700,
        316978,
        "Four-Cornered Hat",
        "hat|camelid fiber|textiles-costumes",
        "ao/mobile-large/DP212590.jpg",
        0.76
    ),
    SearchData(
        1500,
        315253,
        "Copper Lime Spoon with Bird Top",
        "lime spoon|copper (cast)|metal-implements",
        "ao/mobile-large/VS1987_394_192.JPG",
        0.61
    ),
    SearchData(
        1500,
        317593,
        "Votive Container (Canopa)",
        "container|stone|stone-containers",
        "ao/mobile-large/1994.35.760.jpg",
        1.51
    ),
    SearchData(
        1500,
        313223,
        "Funerary Staff",
        "tomb post|wood, metal, paint, silver, gold (?)|wood-sculpture",
        "ao/mobile-large/DP-23804-001.jpg",
        0.39
    ),
    SearchData(
        800,
        309229,
        "Tupu (pin)",
        "pin|silver|metal-ornaments",
        "ao/mobile-large/DP-13440-018.jpg",
        1.69
    ),
    SearchData(
        1500,
        313227,
        "Funerary Staffs",
        "tomb staff|wood|wood-sculpture",
        "ao/mobile-large/DP-23811-001.jpg",
        0.42
    ),
    SearchData(
        1475,
        309398,
        "Miniature Jar with Two Handles",
        "jar|ceramic|ceramics-containers",
        "ao/mobile-large/66.30.15.jpg",
        1.12
    ),
    SearchData(
        1475,
        316822,
        "Feathered Tunic",
        "tunic fragment|cotton, feathers|textiles-featherwork",
        "ao/mobile-large/lb1993_474.jpg",
        0.71
    ),
    SearchData(
        950,
        309414,
        "Beaker, Figure with Shell",
        "beaker|gold|metal-containers",
        "ao/mobile-large/66.196.27_a.JPG",
        0.67
    ),
    SearchData(
        750,
        316727,
        "Four-Cornered Hat",
        "hat|camelid hair|textiles-costumes",
        "ao/mobile-large/vs1994.35164a.jpg",
        0.98
    ),
    SearchData(
        750,
        316972,
        "Four-Cornered Hat",
        "hat|camelid hair|textiles-costumes",
        "ao/mobile-large/HZ1994_35_147.jpg",
        1.09
    ),
    SearchData(
        1400,
        318888,
        "Headband",
        "headband|camelid hair|textiles-woven",
        "ao/mobile-large/DP-13440-001.jpg",
        0.95
    ),
    SearchData(
        1550,
        316930,
        "Sling",
        "sling|camelid hair|textiles-woven",
        "ao/mobile-large/DP101341.jpg",
        0.51
    ),
    SearchData(
        1550,
        316920,
        "Bag",
        "bag|camelid hair|textiles-woven",
        "ao/mobile-large/DP18714.jpg",
        1.19
    ),
    SearchData(
        650,
        313010,
        "Figure with Ceremonial Objects",
        "male figure|stone|stone-sculpture",
        "ao/mobile-large/DP-23813-001.jpg",
        0.51
    ),
    SearchData(
        1550,
        316923,
        "Bag",
        "bag|cotton, camelid hair|textiles-woven",
        "ao/mobile-large/DP101296.jpg",
        0.94
    ),
    SearchData(
        1500,
        317752,
        "Lime Spoon, Bird",
        "lime spoon|copper alloy (cast)|metal-implements",
        "ao/mobile-large/DP-18884-002.jpg",
        0.75
    ),
    SearchData(
        1250,
        312669,
        "Panel",
        "panel|cotton, paint|textiles-woven",
        "ao/mobile-large/1979_206_459_EX_01.jpg",
        1.77
    ),
    SearchData(
        750,
        316987,
        "Four-Cornered Hat",
        "hat|camelid hair|textiles-costumes",
        "ao/mobile-large/HZ1994_35_167.jpg",
        1.06
    ),
    SearchData(
        750,
        316343,
        "Four-Cornered Hat",
        "hat|camelid hair|textiles-costumes",
        "ao/mobile-large/HZ1994_35_153.jpg",
        1.12
    ),
    SearchData(
        600,
        315155,
        "Stirrup Spout Bottle with Warrior",
        "bottle|ceramic, slip|ceramics-containers",
        "ao/mobile-large/1987.394.93.JPG",
        0.67
    ),
    SearchData(
        1450,
        308770,
        "Ceremonial Knife (Tumi)",
        "knife|copper|metal-implements",
        "ao/mobile-large/64.228.242.JPG",
        1.26
    ),
    SearchData(
        1475,
        316838,
        "Kero",
        "kero|wood|wood-containers",
        "ao/mobile-large/vs1994_35_10.jpg",
        0.75
    ),
    SearchData(
        1491,
        316938,
        "Serpent ornament",
        "ornament|cotton, camelid hair|textiles-woven",
        "ao/mobile-large/1994.35.113_d.JPG",
        1.50
    ),
    SearchData(
        1500,
        312726,
        "Ornamental Knife",
        "knife|copper|metal-implements",
        "ao/mobile-large/1979.206.516.JPG",
        0.67
    ),
    SearchData(
        1475,
        310233,
        "Blackware Paccha with Feline",
        "paccha|ceramic|ceramics-containers",
        "ao/mobile-large/1976.287.42.jpg",
        1.23
    ),
    SearchData(
        1450,
        318338,
        "Votive Container (Canopa)",
        "container|stone|stone-containers",
        "ao/mobile-large/1999.367.1.jpg",
        1.50
    ),
    SearchData(
        1700,
        316851,
        "Kero",
        "kero|wood, metal stud and pigmented resin inlays|wood-containers",
        "ao/mobile-large/hz1994_35_23.jpg",
        0.68
    ),
    SearchData(
        1600,
        320804,
        "Hanging (?) Fragment",
        "tapestry fragment|camelid hair, cotton|textiles-woven",
        "ao/mobile-large/TR.489.2010_a.jpg",
        0.52
    ),
    SearchData(
        1500,
        310667,
        "Tomb Post",
        "tomb post|wood, silver sheathing, feathers|metal-sculpture",
        "ao/mobile-large/vs1978.412.222.jpg",
        0.28
    ),
    SearchData(
        750,
        314621,
        "Four-Cornered Hat",
        "hat|camelid hair|textiles-costumes",
        "ao/mobile-large/HZ1983_497_4.jpg",
        1.03
    ),
    SearchData(
        450,
        314679,
        "Fox Warrior Bottle",
        "bottle|ceramic, slip, pigment|ceramics-containers",
        "ao/mobile-large/DP227399.jpg",
        0.75
    ),
    SearchData(
        1500,
        315254,
        "Copper Lime Spoon with Bird Top",
        "lime spoon|copper (cast)|metal-implements",
        "ao/mobile-large/VS1987_394_193.JPG",
        0.48
    ),
    SearchData(
        550,
        309428,
        "Ear Ornament, Winged Runner",
        "earflare|gold, turquoise, sodalite, shell|metal-ornaments",
        "ao/mobile-large/66.196.41.jpg",
        0.90
    ),
    SearchData(
        750,
        314620,
        "Four-Cornered Hat",
        "hat|camelid hair|textiles-costumes",
        "ao/mobile-large/hz1983_497_3.jpg",
        1.15
    ),
    SearchData(
        800,
        315686,
        "Four-Cornered Hat",
        "hat|camelid hair|textiles-costumes",
        "ao/mobile-large/250467.jpg",
        0.90
    ),
    SearchData(
        1500,
        315426,
        "Copper Lime Spoon in Snake Form",
        "lime spoon|copper (cast)|metal-ornaments",
        "ao/mobile-large/VS1987_394_577.JPG",
        0.27
    ),
    SearchData(
        1500,
        315307,
        "Ball",
        "ball|brass (cast), copper|metal-implements",
        "ao/mobile-large/vs1987_394_246_7.JPG",
        0.72
    ),
    SearchData(
        1450,
        318339,
        "Votive Container (Canopa)",
        "container|stone|stone-containers",
        "ao/mobile-large/1999.367.2.jpg",
        1.27
    ),
    SearchData(
        1500,
        313056,
        "Funerary Staffs",
        "tomb staff|wood, paint|wood-sculpture",
        "ao/mobile-large/DP-23810-001.jpg",
        0.43
    ),
    SearchData(
        1500,
        308123,
        "Beaker with scroll ornamentation",
        "beaker|silver, gold|metal-containers",
        "ao/mobile-large/vs33_149_103.jpg",
        0.55
    ),
    SearchData(
        1450,
        314614,
        "Cap Woven with Human Hair",
        "hat|camelid hair, human hair|textiles-woven",
        "ao/mobile-large/250580.jpg",
        0.58
    ),
    SearchData(
        1600,
        314616,
        "Woven Sling Shot",
        "sling shot|camelid hair|textiles-woven",
        "ao/mobile-large/250582.jpg",
        2.14
    ),
    SearchData(
        1500,
        315487,
        "Ornamented Knife",
        "knife|copper|metal-implements",
        "ao/mobile-large/hz1987_394_412.jpg",
        1.18
    ),
    SearchData(
        1500,
        313274,
        "Male Effigy Vessel",
        "vessel|ceramic, pigment|ceramics-containers",
        "ao/mobile-large/1979.206.1081_a.jpg",
        0.71
    ),
    SearchData(
        1465,
        319574,
        "Tunic",
        "tunic|camelid fiber|textiles-woven",
        "ao/mobile-large/DP120795.jpg",
        0.95
    ),
    SearchData(
        1400,
        315610,
        "Group of pins",
        "pin|silver (hammered)|metal-ornaments",
        "ao/mobile-large/DP219006.jpg",
        0.67
    ),
    SearchData(
        1500,
        315284,
        "Copper Pin",
        "pin|copper, gilt|metal-ornaments",
        "ao/mobile-large/vs1987_394_224.JPG",
        0.33
    ),
    SearchData(
        500,
        309438,
        "Bird Warrior Bottle",
        "bottle|ceramic, pigment|ceramics-containers",
        "ao/mobile-large/67.167.2.jpg",
        0.67
    ),
    SearchData(
        1466,
        309943,
        "Male figurine",
        "figure|gold-silver alloy|sculpture-sheet metal",
        "ao/mobile-large/DP-13440-014.jpg",
        0.76
    ),
    SearchData(
        1530,
        313273,
        "Ear Spool",
        "ear spool|gold, silver|metal-ornaments",
        "ao/mobile-large/vs1979_206_1079_80.jpg",
        1.84
    ),
    SearchData(
        1650,
        316848,
        "Kero",
        "kero|wood (prosopis?), copper/silver alloy inlay|wood-containers",
        "ao/mobile-large/DT239579.jpg",
        0.80
    ),
    SearchData(
        1500,
        308083,
        "Tapestry Fragment",
        "textile fragment|camelid hair|textiles-woven",
        "ao/mobile-large/DP101353.jpg",
        1.31
    ),
    SearchData(
        1491,
        316929,
        "Sling",
        "sling|camelid hair|textiles-woven",
        "ao/mobile-large/DP101340.jpg",
        0.72
    ),
    SearchData(
        600,
        315133,
        "Profile Warrior Ornament",
        "ornament|gilded copper, shell turquoise|metal-ornaments",
        "ao/mobile-large/1987.394.70.JPG",
        0.76
    ),
    SearchData(
        1500,
        315635,
        "Figure Lime Spoon",
        "lime spoon|copper|metal-implements",
        "ao/mobile-large/1987.394.586.jpg",
        0.67
    ),
    SearchData(
        1500,
        310702,
        "Storage Jar (aryballos)",
        "bottle|ceramic|ceramics-containers",
        "ao/mobile-large/vs1978_412_258.jpg",
        0.79
    ),
    SearchData(
        1500,
        313053,
        "Funerary Staffs",
        "tomb staff|wood, paint, metal|wood-sculpture",
        "ao/mobile-large/DP-23809-001.jpg",
        0.28
    ),
    SearchData(
        1500,
        315425,
        "Lime Spoon",
        "lime spoon|silver (cast)|metal-ornaments",
        "ao/mobile-large/VS1987_394_576.JPG",
        0.38
    ),
    SearchData(
        1049,
        309959,
        "Funerary Mask",
        "mask|gold, silver-copper overlays, cinnabar|metal-sculpture",
        "ao/mobile-large/DT1274.jpg",
        1.25
    ),
    SearchData(
        200,
        314874,
        "Cutout Disk, Crab and Fish",
        "disk|gilded copper|metal-ornaments",
        "ao/mobile-large/DT5791.jpg",
        0.80
    ),
    SearchData(
        1500,
        315260,
        "Pin",
        "pin|silver (cast)|metal-ornaments",
        "ao/mobile-large/vs1987_394_200.JPG",
        0.40
    ),
    SearchData(
        1650,
        320054,
        "Miniature Tabard",
        "tunic|cotton, camelid hair, silk, metal|textiles-woven",
        "ao/mobile-large/DP107700.jpg",
        0.79
    ),
    SearchData(
        600,
        315191,
        "Disc",
        "ornament|gilded copper|metal-ornaments",
        "ao/mobile-large/1987.394.129.JPG",
        1.30
    ),
    SearchData(
        1250,
        319053,
        "Collar",
        "collar|spondylus shell and black stone beads, cotton|beads-costumes",
        "ao/mobile-large/DP216742.jpg",
        1.37
    ),
    SearchData(
        1500,
        315354,
        "Ceremonial Knife (Tumi)",
        "knife|copper (cast), silver (?)|metal-implements",
        "ao/mobile-large/vs1987_394_309.jpg",
        0.93
    ),
    SearchData(
        1500,
        315251,
        "Copper Lime Spoon with Bird Top",
        "lime spoon|copper (cast)|metal-implements",
        "ao/mobile-large/VS1987_394_190.JPG",
        0.38
    ),
    SearchData(
        750,
        316985,
        "Four-Cornered Hat",
        "hat|camelid hair|textiles-costumes",
        "ao/mobile-large/HZ1994_35_165.jpg",
        1.02
    ),
    SearchData(
        400,
        310601,
        "Ritual Scene Vessel",
        "vessel|ceramic|ceramics-containers",
        "ao/mobile-large/DP-24357-001.jpg",
        1.33
    ),
    SearchData(
        1475,
        316837,
        "Kero",
        "kero|wood (prosopis ?)|wood-containers",
        "ao/mobile-large/DP104801.jpg",
        0.83
    ),
    SearchData(
        500,
        309304,
        "Stirrup Spout Bottle with Cat",
        "bottle|ceramic, slip|ceramics-containers",
        "ao/mobile-large/65.266.6.JPG",
        0.67
    ),
    SearchData(
        1500,
        315248,
        "Copper Pin",
        "pin|copper (cast)|metal-ornaments",
        "ao/mobile-large/vs1987_394_187.JPG",
        0.34
    ),
    SearchData(
        1500,
        315690,
        "Bag",
        "bag|camelid hair, cotton|textiles-woven",
        "ao/mobile-large/DP18706_1987.394.642.jpg",
        0.82
    ),
    SearchData(
        1466,
        312558,
        "Female Figurine",
        "figure|silver|sculpture-sheet metal",
        "ao/mobile-large/DP-13440-027.jpg",
        0.67
    ),
    SearchData(
        500,
        308527,
        "Portrait Head Bottle",
        "bottle|ceramic, slip, pigment|ceramics-containers",
        "ao/mobile-large/DP-23630-001.jpg",
        0.75
    ),
    SearchData(
        -500,
        308426,
        "Bottle, Feline face",
        "bottle|ceramic, post-fired paint|ceramics-containers",
        "ao/mobile-large/63.232.9.jpg",
        0.75
    ),
    SearchData(
        1500,
        315708,
        "Band Fragment",
        "textile fragment|cotton, camelid hair|textiles-woven",
        "ao/mobile-large/DP18703.jpg",
        0.35
    ),
    SearchData(
        1500,
        314954,
        "Paccha (ritual vessel)",
        "vessel|ceramic, slip|ceramics-containers",
        "ao/mobile-large/DP-23632-001.jpg",
        1.06
    ),
    SearchData(
        1500,
        312636,
        "Ornamental Pin (Tupu)",
        "pin|bronze|metal-ornaments",
        "ao/mobile-large/vs1979_206_416aa.jpg",
        0.38
    ),
    SearchData(
        1850,
        29313,
        "Pair of Stirrups",
        "stirrups|wood, iron|equestrian equipment-stirrups",
        "aa/mobile-large/LC-42_50_440_441-007.jpg",
        1.50
    ),
    SearchData(
        750,
        316968,
        "Four-Cornered Hat",
        "hat|camelid hair|textiles-costumes",
        "ao/mobile-large/HZ1994_35_143.jpg",
        1.13
    ),
    SearchData(
        750,
        312672,
        "Mantle",
        "mantle|cotton, camelid hair|textiles-woven",
        "ao/mobile-large/DP264884.jpg",
        1.02
    ),
    SearchData(
        1500,
        315242,
        "Ceremonial Knife (Tumi)",
        "knife|copper (cast)|metal-implements",
        "ao/mobile-large/1987.394.181.jpg",
        0.67
    ),
    SearchData(
        600,
        313398,
        "Nose Ornament, Turbaned Head",
        "ornament|gold (partially silvered), silver|metal-ornaments",
        "ao/mobile-large/DP-16100-001.jpg",
        1.33
    ),
    SearchData(
        1200,
        307471,
        "Border Fragment",
        "border fragment|camelid hair, cotton|textiles-woven",
        "ao/mobile-large/DP101363.jpg",
        1.12
    ),
    SearchData(
        1500,
        313054,
        "Funerary Staffs",
        "tomb staff|wood, paint|wood-sculpture",
        "ao/mobile-large/DP-22195-004.jpg",
        0.65
    ),
    SearchData(
        550,
        316983,
        "Four-Cornered Hat",
        "hat|camelid hair|textiles-costumes",
        "ao/mobile-large/HZ1994_35_163.jpg",
        0.90
    ),
    SearchData(
        1515,
        313324,
        "Sleeveless Tunic",
        "tunic|cotton, camelid hair|textiles-woven",
        "ao/mobile-large/1979.206.1131_a.jpg",
        0.77
    ),
    SearchData(
        550,
        319459,
        "Pair of Ear Ornaments with Winged Runners",
        "earflare|gold, turquoise, sodalite, shell|metal-ornaments",
        "ao/mobile-large/DP-10734-01.jpg",
        1.35
    ),
    SearchData(
        1500,
        315338,
        "Knife (?)",
        "knife|copper|metal-implements",
        "ao/mobile-large/vs1987_394_293.jpg",
        1.29
    ),
    SearchData(
        1410,
        316437,
        "Earflare with Multifigure Scene",
        "earflare|gold|metal-ornaments",
        "ao/mobile-large/DP370837.jpg",
        0.99
    ),
    SearchData(
        1500,
        315613,
        "Silver Pin",
        "pin|silver (hammered)|metal-ornaments",
        "ao/mobile-large/vs1987_394_553.JPG",
        0.39
    ),
    SearchData(
        1475,
        316836,
        "Kero",
        "kero|wood (prosopis ?)|wood-containers",
        "ao/mobile-large/hz1994_35_8.jpg",
        0.77
    ),
    SearchData(
        -550,
        307622,
        "Double Spout and Bridge Bottle",
        "bottle|ceramic, pigment|ceramics-containers",
        "ao/mobile-large/64.228.97_a.jpg",
        1.09
    ),
    SearchData(
        1500,
        313267,
        "Kero",
        "kero|wood|wood-containers",
        "ao/mobile-large/1979.206.1074.jpg",
        1.00
    ),
    SearchData(
        1500,
        308120,
        "Eight-Pointed Star Tunic",
        "tunic|camelid hair, cotton|textiles-woven",
        "ao/mobile-large/ra33.149.100.R.jpg",
        0.81
    ),
    SearchData(
        1462,
        319524,
        "Fragmentary Woman\"s Dress",
        "dress fragment|camelid fiber|textiles-woven",
        "ao/mobile-large/2004.406_detail.jpg",
        0.67
    ),
    SearchData(
        600,
        313411,
        "Nose Ornament with Shrimp",
        "nose ornament|gold, silver, stone|metal-ornaments",
        "ao/mobile-large/DT9425.jpg",
        1.25
    ),
    SearchData(
        450,
        318746,
        "Belt",
        "belt|camelid fiber|textiles-woven",
        "ao/mobile-large/2001.172_b.jpg",
        0.38
    ),
    SearchData(
        500,
        309441,
        "Raptorial Bird Bottle",
        "bottle|ceramic, pigment|ceramics-containers",
        "ao/mobile-large/67.167.6.JPG",
        0.67
    ),
    SearchData(
        850,
        316976,
        "Four-Cornered Hat",
        "hat|camelid hair|textiles-costumes",
        "ao/mobile-large/HZ1994_35_156.jpg",
        1.24
    ),
    SearchData(
        650,
        316979,
        "Four-Cornered Hat",
        "hat|camelid hair|textiles-costumes",
        "ao/mobile-large/DT3833.jpg",
        0.80
    ),
    SearchData(
        1500,
        315653,
        "Copper Tumi with Figure",
        "knife|copper|metal-implements",
        "ao/mobile-large/vs1987_394_605.jpg",
        1.02
    ),
    SearchData(
        550,
        308383,
        "Spectacled Bear Bottle",
        "bottle|ceramic, slip|ceramics-containers",
        "ao/mobile-large/63.112.5.JPG",
        0.67
    ),
    SearchData(
        1475,
        317726,
        "Tumi with Figure",
        "knife|copper|metal-implements",
        "ao/mobile-large/VS1995_63_1.JPG",
        1.06
    ),
    SearchData(
        1399,
        310619,
        "Bottle, Audiencias with Figures",
        "vessel|silver|metal-containers",
        "ao/mobile-large/DP338094.jpg",
        1.33
    ),
    SearchData(
        800,
        316975,
        "Four-Cornered Hat",
        "hat|camelid hair|textiles-costumes",
        "ao/mobile-large/HZ1994_35_155.jpg",
        1.10
    ),
    SearchData(
        1700,
        316892,
        "Woman\"s Mantle (lliclla)",
        "mantle|camelid hair|textiles-woven",
        "ao/mobile-large/DT3832rev.jpg",
        1.25
    ),
    SearchData(
        1475,
        316834,
        "Paccha",
        "paccha|wood|wood-containers",
        "ao/mobile-large/vs1994_35_6.jpg",
        1.52
    ),
    SearchData(
        0,
        308455,
        "Bottle, Monkey",
        "bottle|ceramic, slip|ceramics-containers",
        "ao/mobile-large/DP234684.jpg",
        1.13
    ),
    SearchData(
        600,
        314537,
        "Disk",
        "ornament|gilded copper, silvered copper, shell inlay|metal-ornaments",
        "ao/mobile-large/1982.392.8.jpg",
        1.50
    ),
    SearchData(
        1500,
        315636,
        "Lime Spoon, Figure",
        "lime spoon|copper|metal-implements",
        "ao/mobile-large/1987.394.587.jpg",
        0.67
    ),
    SearchData(
        300,
        316270,
        "Corn stalk-shaped vessel",
        "bottle|ceramic, slip|ceramics-containers",
        "ao/mobile-large/DP-23629-001.jpg",
        0.75
    ),
    SearchData(
        650,
        844007,
        "Warrior Figure",
        "figure|turquoise|stone-sculpture",
        "ao/mobile-large/DP-20565-001.jpg",
        0.85
    ),
    SearchData(
        1450,
        316928,
        "Sling",
        "sling|camelid hair|textiles-woven",
        "ao/mobile-large/vs1994.35.103a.jpg",
        1.03
    ),
    SearchData(
        1500,
        315268,
        "Copper Lime Spoon with Bird Top",
        "lime spoon|copper|metal-implements",
        "ao/mobile-large/VS1987_394_208.jpg",
        0.36
    ),
    SearchData(
        700,
        310308,
        "Prisoner Lime Container",
        "lime container|wood, bone inlay, paint, fiber|wood-containers",
        "ao/mobile-large/DP270994.jpg",
        0.90
    ),
    SearchData(
        800,
        309106,
        "Tupu (pin)",
        "pin|copper and gold|metal-ornaments",
        "ao/mobile-large/hz64_228_608.jpg",
        0.40
    ),
    SearchData(
        850,
        314624,
        "Four-Cornered Hat",
        "hat|camelid hair|textiles-costumes",
        "ao/mobile-large/HZ1983_497_7.jpg",
        1.13
    ),
    SearchData(
        350,
        308507,
        "Bottle with Runners",
        "bottle|ceramic, slip|ceramics-containers",
        "ao/mobile-large/64.228.1.JPG",
        0.67
    ),
    SearchData(
        100,
        314776,
        "Ornamental Plume",
        "ornament|gold|metal-ornaments",
        "ao/mobile-large/DT7665.jpg",
        0.57
    ),
    SearchData(
        1450,
        315363,
        "Face Beaker",
        "beaker|silver|metal-containers",
        "ao/mobile-large/DT5795.jpg",
        0.61
    ),
    SearchData(
        1750,
        316852,
        "Kero",
        "kero|wood (escallonia?), pigmented resin inlay|wood-containers",
        "ao/mobile-large/hz1994_35_24.jpg",
        1.02
    ),
    SearchData(
        800,
        316982,
        "Four-Cornered Hat",
        "hat|camelid hair|textiles-costumes",
        "ao/mobile-large/HZ1994_35_162.jpg",
        1.01
    ),
    SearchData(
        1500,
        315804,
        "Copper Tumi with Figure",
        "knife|copper|metal-implements",
        "ao/mobile-large/vs1987_394_723.jpg",
        0.89
    ),
    SearchData(
        1849,
        126673,
        "Mantle pin (ttipqui)",
        "pin|silver, glass|metal-ornaments",
        "ao/mobile-large/1982.420.13.jpg",
        0.25
    ),
    SearchData(
        750,
        316977,
        "Four-Cornered Hat",
        "hat|camelid hair|textiles-costumes",
        "ao/mobile-large/HZ1994_35_157.jpg",
        1.16
    ),
    SearchData(
        1500,
        315266,
        "Copper Lime Spoon with Bird Top",
        "lime spoon|copper (cast)|metal-implements",
        "ao/mobile-large/VS1987_394_206.JPG",
        0.87
    ),
    SearchData(
        1400,
        315611,
        "Pin",
        "pin|silver (hammered)|metal-ornaments",
        "ao/mobile-large/vs1987_394_551.JPG",
        0.70
    ),
    SearchData(
        1500,
        315306,
        "Ball",
        "ball|brass (cast)|metal-implements",
        "ao/mobile-large/vs1987_394_246_7.JPG",
        0.72
    ),
    SearchData(
        1500,
        319536,
        "Seated Figure Ornament with Dangles",
        "ornament|silver and thread|metal-ornaments",
        "ao/mobile-large/vs565.jpg",
        0.71
    ),
    SearchData(
        1420,
        317727,
        "Feline Bowl",
        "bowl|stone|stone-containers",
        "ao/mobile-large/1995.63.2_a.jpg",
        1.47
    ),
    SearchData(
        1500,
        315633,
        "Figure Lime Spoon",
        "lime spoon|copper|metal-implements",
        "ao/mobile-large/1987.394.584.jpg",
        0.67
    ),
    SearchData(
        1500,
        317592,
        "Votive Container (Canopa)",
        "vessel|stone|stone-containers",
        "ao/mobile-large/1994.35.759.jpg",
        1.50
    ),
    SearchData(
        750,
        316340,
        "Four-Cornered Hat",
        "hat|camelid hair|textiles-costumes",
        "ao/mobile-large/HZ1994_35_150.jpg",
        1.04
    ),
    SearchData(
        1500,
        309528,
        "Band",
        "band|camelid hair|textiles-woven",
        "ao/mobile-large/189514.jpg",
        2.68
    ),
    SearchData(
        1475,
        309393,
        "Miniature Vessel",
        "miniature dish|ceramic|ceramics-containers",
        "ao/mobile-large/DP-25093-001.jpg",
        2.15
    ),
    SearchData(
        1530,
        313272,
        "Ear Spool",
        "ear spool|gold, silver|metal-ornaments",
        "ao/mobile-large/vs1979_206_1079_80.jpg",
        1.84
    ),
    SearchData(
        1505,
        502538,
        "Whistling Jar",
        "whistling jar|clay|aerophone-blow hole-vessel flute",
        "mi/mobile-large/188965.jpg",
        0.91
    ),
    SearchData(
        1500,
        317594,
        "Votive Container (Canopa)",
        "container|stone|stone-containers",
        "ao/mobile-large/1994.35.761.jpg",
        1.42
    ),
    SearchData(
        1600,
        214310,
        "Woman\"s wedding mantle (lliclla) with interlace and tocapu design",
        "mantle|tapestry weave, cotton warp and camelid weft|",
        "ad/mobile-large/DP265667.jpg",
        1.12
    ),
    SearchData(
        -650,
        310655,
        "Bottle: Leaf-Nosed Bat Head",
        "bottle|ceramic, pigment|ceramics-containers",
        "ao/mobile-large/DP-24265-003.jpg",
        0.78
    ),
    SearchData(
        1500,
        313224,
        "Funerary Staffs",
        "tomb post|wood, paint, metal|wood-sculpture",
        "ao/mobile-large/DP-23802-001.jpg",
        0.36
    ),
    SearchData(
        1500,
        315252,
        "Copper Lime Spoon with Bird Top",
        "lime spoon|copper (cast)|metal-implements",
        "ao/mobile-large/VS1987_394_191.JPG",
        0.42
    ),
    SearchData(
        600,
        315148,
        "Profile Warrior Ornament",
        "ornament|gilded copper, shell, turquoise|metal-ornaments",
        "ao/mobile-large/1987.394.86.JPG",
        0.88
    ),
    SearchData(
        1500,
        315667,
        "Copper Atlatl Spear Thrower",
        "spear thrower|copper (cast)|metal-implements",
        "ao/mobile-large/vs1987_394_619.JPG",
        1.33
    ),
    SearchData(
        700,
        314623,
        "Four-Cornered Hat",
        "hat|camelid fiber|textiles-costumes",
        "ao/mobile-large/DP264888.jpg",
        0.83
    ),
    SearchData(
        1500,
        310668,
        "Tomb Post",
        "tomb post|wood, silver sheathing, feathers|metal-sculpture",
        "ao/mobile-large/vs1978.412.223.jpg",
        0.27
    ),
    SearchData(
        1466,
        309960,
        "Camelid figurine",
        "figure|alloys of silver, gold and copper|metalwork-sculpture",
        "ao/mobile-large/DP-13440-031.jpg",
        0.76
    ),
    SearchData(
        1250,
        313148,
        "Weaving Basket",
        "basket with weaving implements|cane, shell, bone, fiber, camelid hair, wood, pigment, metal, stone|textiles-implements",
        "ao/mobile-large/1979.206.950.1_a.JPG",
        1.50
    ),
    SearchData(
        1550,
        316840,
        "Kero",
        "kero|wood, pigmented resin inlay|wood-containers",
        "ao/mobile-large/hz1994_35_12.jpg",
        0.75
    ),
    SearchData(
        1500,
        319319,
        "Kero",
        "kero|ceramic|ceramics-containers",
        "ao/mobile-large/hzTR355_1_2003.jpg",
        0.86
    ),
    SearchData(
        600,
        314878,
        "Cutout Disk",
        "ornament|gilded copper|metal-ornaments",
        "ao/mobile-large/1987.394.50.JPG",
        1.22
    ),
    SearchData(
        1500,
        313204,
        "Dish with Bird Head",
        "dish|ceramic, pigment|ceramics-containers",
        "ao/mobile-large/1979.206.1007.jpg",
        1.58
    ),
    SearchData(
        1500,
        315771,
        "Votive Container (Canopa)",
        "container|stone|stone-containers",
        "ao/mobile-large/vs1987.394.691.jpg",
        1.17
    ),
    SearchData(
        350,
        308510,
        "Bottle, Warriors",
        "bottle|ceramic, slip, pigment|ceramics-containers",
        "ao/mobile-large/64.228.4.JPG",
        0.67
    ),
    SearchData(
        750,
        316989,
        "Four-Cornered Hat",
        "hat|camelid hair|textiles-costumes",
        "ao/mobile-large/HZ1994_35_169.jpg",
        1.12
    ),
    SearchData(
        1150,
        320329,
        "Monkey Pendant",
        "pendant|gold|metal-ornaments",
        "ao/mobile-large/TR.394.18.2008 Back.jpg",
        2.21
    ),
    SearchData(
        1500,
        315639,
        "Silver Lime Spoon with Fish Top",
        "lime spoon|silver (cast)|metal-implements",
        "ao/mobile-large/vs1987_394_590.jpg",
        0.48
    ),
    SearchData(
        550,
        316984,
        "Four-Cornered Hat",
        "hat|camelid hair|textiles-costumes",
        "ao/mobile-large/1994.35.164_b.jpg",
        0.74
    ),
    SearchData(
        400,
        308540,
        "Stirrup Spout Bottle with Seated Figure",
        "bottle|ceramic, slip|ceramics-containers",
        "ao/mobile-large/LC-64_228_34_TMS3.jpg",
        0.66
    ),
    SearchData(
        1200,
        312826,
        "Miniature Dress",
        "miniature dress|cotton, feathers|textiles-featherwork",
        "ao/mobile-large/DP224272.jpg",
        1.33
    ),
    SearchData(
        1650,
        316853,
        "Kero",
        "kero|wood (escallonia), pigmented resin inlay|wood-containers",
        "ao/mobile-large/hz1994_35_25.jpg",
        1.36
    ),
    SearchData(
        50,
        313364,
        "Nose Ornament with Spiders",
        "nose ornament|gold|metal-ornaments",
        "ao/mobile-large/DP313281.jpg",
        1.33
    ),
    SearchData(
        650,
        308410,
        "Stirrup spout bottle with warrior",
        "bottle|ceramic, slip|ceramics-containers",
        "ao/mobile-large/DP-23622-001.jpg",
        0.75
    ),
    SearchData(
        1400,
        308555,
        "Double Chambered Bottle",
        "bottle|ceramic|ceramics-containers",
        "ao/mobile-large/64.228.54_b.jpg",
        1.05
    ),
    SearchData(
        1466,
        315668,
        "Tupu (pin)",
        "pin|copper or alloy of copper|metal-ornaments",
        "ao/mobile-large/DP-13440-020.jpg",
        1.69
    ),
    SearchData(
        1500,
        315294,
        "Mace Head",
        "mace head|silver (cast)|metal-implements",
        "ao/mobile-large/DP-20709-001.jpg",
        1.09
    ),
    SearchData(
        1238,
        646249,
        "Man\"s Tunic",
        "tunic|camelid and cotton fibers|textiles-costumes",
        "ao/mobile-large/TR.113.2014_image_001.jpg",
        0.89
    ),
    SearchData(
        1549,
        751901,
        "Checkerboard Tunic",
        "tunic|camelid fiber|textiles-costumes",
        "ao/mobile-large/DP-14281-001.jpg",
        0.88
    ),
    SearchData(
        1475,
        317791,
        "Kero",
        "kero|wood (prosopis?)|wood-containers",
        "ao/mobile-large/DP104877.jpg",
        1.01
    ),
    SearchData(
        1500,
        313289,
        "Vessel, Hand with Kero",
        "kero|ceramic, pigment|ceramics-containers",
        "ao/mobile-large/1979.206.1096_b.jpg",
        1.40
    ),
    SearchData(
        1475,
        309399,
        "Miniature Jar",
        "jar|ceramic|ceramics-containers",
        "ao/mobile-large/66.30.16.jpg",
        1.09
    ),
    SearchData(
        750,
        316969,
        "Four-Cornered Hat",
        "hat|camelid hair|textiles-costumes",
        "ao/mobile-large/HZ1994_35_144.jpg",
        1.07
    ),
    SearchData(
        1462,
        319487,
        "Kero",
        "kero|wood|wood-containers",
        "ao/mobile-large/DP-13440-026.jpg",
        0.86
    ),
    SearchData(
        1500,
        315476,
        "Axe",
        "axe|bronze|metal-implements",
        "ao/mobile-large/vs1987_394_401.JPG",
        0.45
    ),
    SearchData(
        1550,
        316922,
        "Bag",
        "bag|cotton, camelid hair|textiles-woven",
        "ao/mobile-large/DP101295.jpg",
        0.93
    ),
    SearchData(
        1420,
        313295,
        "Face Beaker",
        "beaker|silver|metal-containers",
        "ao/mobile-large/DT9410.jpg",
        0.80
    ),
    SearchData(
        1600,
        314617,
        "Woven Sling Shot",
        "sling shot|camelid hair|textiles-woven",
        "ao/mobile-large/250583.jpg",
        2.00
    ),
    SearchData(
        750,
        833953,
        "Tapestry Tunic",
        "tunic|camelid wool|textiles-woven",
        "ao/mobile-large/DP-18736-001.jpg",
        0.95
    ),
    SearchData(
        850,
        316974,
        "Four-Cornered Hat",
        "hat|camelid hair|textiles-costumes",
        "ao/mobile-large/HZ1994_35_154.jpg",
        1.08
    ),
    SearchData(
        750,
        316967,
        "Four-Cornered Hat",
        "hat|camelid hair|textiles-costumes",
        "ao/mobile-large/HZ1994_35_142.jpg",
        1.04
    ),
    SearchData(
        1500,
        315773,
        "Sling Shot",
        "sling shot|camelid hair|textiles-woven",
        "ao/mobile-large/250471.jpg",
        2.17
    ),
    SearchData(
        650,
        307472,
        "Bottle with portrait head",
        "bottle|ceramic, slip|ceramics-containers",
        "ao/mobile-large/DP-24066-002.jpg",
        0.75
    ),
    SearchData(
        1500,
        315637,
        "Figure Lime Spoon",
        "lime spoon|copper (cast)|metal-implements",
        "ao/mobile-large/1987.394.588.jpg",
        0.67
    ),
    SearchData(
        1500,
        315619,
        "Silver Pin",
        "pin|silver (hammered)|metal-ornaments",
        "ao/mobile-large/vs1987_394_559.JPG",
        0.64
    ),
    SearchData(
        1500,
        314955,
        "Paccha (ritual vessel)",
        "vessel|ceramic, slip|ceramics-containers",
        "ao/mobile-large/vs1986_383_2.jpg",
        1.22
    ),
    SearchData(
        -400,
        308487,
        "Double Spouted Vessel with Snake",
        "bottle|ceramic, post-fired paint|ceramics-containers",
        "ao/mobile-large/63.232.84.jpg",
        1.40
    ),
    SearchData(
        1500,
        315770,
        "Votive Container (Canopa)",
        "container|stone|stone-containers",
        "ao/mobile-large/1987.394.690.jpg",
        1.31
    ),
    SearchData(
        500,
        309447,
        "Spotted Feline Bottle",
        "bottle|ceramic, pigment|ceramics-containers",
        "ao/mobile-large/67.167.12.JPG",
        0.67
    ),
    SearchData(
        -350,
        308590,
        "Double Spout and Bridge Bottle with Snake",
        "bottle|ceramic, pigment|ceramics-containers",
        "ao/mobile-large/64.228.89_a.jpg",
        1.17
    ),
    SearchData(
        1500,
        309760,
        "Painted Aryballus Jar",
        "bottle|ceramic, pigment, slip|ceramics-containers",
        "ao/mobile-large/1970.246.7.jpg",
        0.84
    ),
    SearchData(
        -250,
        308491,
        "Miniature Effigy Vessel",
        "bottle|ceramic, post-fired paint|ceramics-containers",
        "ao/mobile-large/63.232.88.jpg",
        1.02
    ),
    SearchData(
        1500,
        315255,
        "Copper Lime Spoon with Bird Top",
        "lime spoon|copper (cast)|metal-implements",
        "ao/mobile-large/VS1987_394_194.JPG",
        0.42
    ),
    SearchData(
        250,
        308537,
        "Stirrup Spout Bottle with Warrior Figure",
        "bottle|ceramic, slip|ceramics-containers",
        "ao/mobile-large/64.228.31.jpg",
        0.67
    ),
    SearchData(
        1410,
        316436,
        "Earflare with Multifigure Scene",
        "earflare|gold|metal-ornaments",
        "ao/mobile-large/DP370836.jpg",
        0.99
    ),
    SearchData(
        750,
        316981,
        "Four-Cornered Hat",
        "hat|camelid hair|textiles-costumes",
        "ao/mobile-large/HZ1994_35_161.jpg",
        0.99
    ),
    SearchData(
        1466,
        315492,
        "Male Figurine",
        "figure|silver|sculpture-sheet metal",
        "ao/mobile-large/DP-13440-021.jpg",
        0.68
    ),
    SearchData(
        1500,
        307846,
        "Panel with Birds",
        "panel|camelid hair|textiles-woven",
        "ao/mobile-large/88392.jpg",
        1.07
    ),
    SearchData(
        75,
        319223,
        "Neck Emblem or Sash",
        "emblem or sash|camelid and human hair|textiles-woven",
        "ao/mobile-large/DT5611.jpg",
        0.28
    ),
    SearchData(
        800,
        309228,
        "Tupu",
        "pin|silver|metal-ornaments",
        "ao/mobile-large/DP-13440-016.jpg",
        1.69
    ),
    SearchData(
        1500,
        315638,
        "Figure Lime Spoon",
        "lime spoon|copper|metal-implements",
        "ao/mobile-large/1987.394.589.jpg",
        0.67
    ),
    SearchData(
        1500,
        315701,
        "Vessel, Leg",
        "vessel|ceramic, pigment|ceramics-containers",
        "ao/mobile-large/1987.394.653_a.jpg",
        0.67
    ),
    SearchData(
        1600,
        316844,
        "Kero",
        "kero|wood, pigmented resin inlay|wood-containers",
        "ao/mobile-large/hz1994_35_16.jpg",
        0.70
    ),
    SearchData(
        1500,
        308079,
        "Tapestry Panel with Stars",
        "panel|camelid hair, cotton|textiles-woven",
        "ao/mobile-large/DP18702_33.149.44.jpg",
        0.71
    ),
    SearchData(
        1300,
        312568,
        "Standing Female Figure",
        "figure|wood, pigment|wood-sculpture",
        "ao/mobile-large/DP-23635-002.jpg",
        0.52
    ),
    SearchData(
        1500,
        315614,
        "Silver Pin",
        "pin|silver (hammered)|metal-ornaments",
        "ao/mobile-large/vs1987_394_554.JPG",
        0.64
    ),
    SearchData(
        1600,
        698417,
        "Pair of Keros",
        "kero|wood, pigmented resin inlay|wood-containers",
        "ao/mobile-large/DP104802.jpg",
        1.06
    ),
    SearchData(
        1500,
        315250,
        "Copper Lime Spoon with Bird Top",
        "lime spoon|copper (cast)|metal-implements",
        "ao/mobile-large/VS1987_394_189.JPG",
        0.49
    ),
    SearchData(
        1650,
        318164,
        "Poncho",
        "poncho|wool|textiles-woven",
        "ao/mobile-large/DP137349.jpg",
        1.76
    ),
    SearchData(
        400,
        308732,
        "Figure of an Owl",
        "figure|bone, cinnabar|bone/ivory-sculpture",
        "ao/mobile-large/DP224140.jpg",
        0.75
    ),
    SearchData(
        1500,
        313055,
        "Funerary Staff",
        "tomb staff|wood, paint, metal, copper|wood-sculpture",
        "ao/mobile-large/DP-23806-001.jpg",
        0.32
    ),
    SearchData(
        1475,
        309391,
        "Miniature Vessel",
        "miniature dish|ceramic|ceramics-containers",
        "ao/mobile-large/DP-24276-001.jpg",
        1.11
    ),
    SearchData(
        -200,
        308298,
        "Bottle, Falcon",
        "bottle|ceramic, pigment|ceramics-containers",
        "ao/mobile-large/62.266.8.jpg",
        0.93
    ),
    SearchData(
        1500,
        307475,
        "Knife (Tumi)",
        "knife|copper|metal-implements",
        "ao/mobile-large/82.1.31_a.JPG",
        1.50
    ),
    SearchData(
        1500,
        315479,
        "Knife",
        "knife|copper|metal-implements",
        "ao/mobile-large/vs1987_394_404.jpg",
        0.37
    ),
    SearchData(
        1500,
        315616,
        "Pin",
        "pin|silver (hammered)|metal-ornaments",
        "ao/mobile-large/vs1987_394_556.JPG",
        0.62
    ),
    SearchData(
        650,
        312940,
        "Bird Pin or Spatula",
        "lime spatula or pin|gold|metal-implements",
        "ao/mobile-large/271370.jpg",
        1.30
    ),
    SearchData(
        500,
        309439,
        "Warrior Bottle",
        "bottle|ceramic|ceramics-containers",
        "ao/mobile-large/DP229470.jpg",
        0.75
    ),
    SearchData(
        750,
        316971,
        "Four-Cornered Hat",
        "hat|camelid hair|textiles-costumes",
        "ao/mobile-large/HZ1994_35_146.jpg",
        1.12
    ),
    SearchData(
        1575,
        316842,
        "Kero",
        "kero|wood (escallonia ?), pigmented resin inlay|wood-containers",
        "ao/mobile-large/DP104799.jpg",
        0.97
    ),
    SearchData(
        1475,
        316839,
        "Kero",
        "kero|wood (escallonia ?)|wood-containers",
        "ao/mobile-large/DP104864.jpg",
        0.94
    ),
    SearchData(
        1500,
        315615,
        "Silver Pin",
        "pin|silver (hammered)|metal-ornaments",
        "ao/mobile-large/vs1987_394_555.JPG",
        0.82
    ),
    SearchData(
        600,
        315135,
        "Profile Warrior Ornament",
        "ornament|copper, shell|metal-ornaments",
        "ao/mobile-large/1987.394.73.JPG",
        0.74
    ),
    SearchData(
        1466,
        315651,
        "Tupu (pin)",
        "pin|copper|metal-ornaments",
        "ao/mobile-large/VS1987_394_603.JPG",
        0.58
    ),
    SearchData(
        1475,
        310520,
        "Small urpu (Jar)",
        "bottle|ceramic, slip|ceramics-containers",
        "ao/mobile-large/DP-24355-001.jpg",
        0.75
    ),
    SearchData(
        1500,
        315612,
        "Pin",
        "pin|silver (hammered)|metal-ornaments",
        "ao/mobile-large/vs1987_394_552.JPG",
        0.44
    ),
    SearchData(
        650,
        315136,
        "Profile Warrior Ornament",
        "ornament|silvered copper, shell|metal-ornaments",
        "ao/mobile-large/1987.394.74.JPG",
        0.71
    ),
    SearchData(
        750,
        316966,
        "Four-Cornered Hat",
        "hat|camelid hair|textiles-costumes",
        "ao/mobile-large/HZ1994_35_141.jpg",
        1.06
    ),
    SearchData(
        1500,
        315623,
        "Silver Pin",
        "pin|silver|metal-ornaments",
        "ao/mobile-large/VS1987_394_563.jpg",
        0.39
    ),
    SearchData(
        1475,
        316926,
        "Feathered Bag",
        "bag|cotton, feathers|textiles-featherwork",
        "ao/mobile-large/DP158704.jpg",
        0.75
    ),
    SearchData(
        600,
        314705,
        "Cutout Disk",
        "ornament|gilded copper|metal-ornaments",
        "ao/mobile-large/1987.394.35.JPG",
        1.50
    ),
    SearchData(
        1650,
        316854,
        "Kero",
        "kero|wood (escallonia), pigmented resin inlay|wood-containers",
        "ao/mobile-large/1994.35.26_a.JPG",
        0.67
    ),
    SearchData(
        1350,
        313268,
        "Lime Spoon with Seated Figure",
        "lime spoon|silver (cast)|metal-implements",
        "ao/mobile-large/vs1979_206_1075.jpg",
        0.29
    ),
    SearchData(
        1000,
        309123,
        "Crown",
        "crown|gold|metal-ornaments",
        "ao/mobile-large/DP-12423-001.jpg",
        0.88
    ),
    SearchData(
        1475,
        309392,
        "Miniature Dish with Handle",
        "dish|ceramic|ceramics-containers",
        "ao/mobile-large/DP-13440-005.jpg",
        1.82
    ),
    SearchData(
        750,
        316342,
        "Four-Cornered Hat",
        "hat|camelid hair|textiles-costumes",
        "ao/mobile-large/HZ1994_35_152.jpg",
        1.17
    ),
    SearchData(
        1475,
        309395,
        "Miniature Vessel",
        "miniature bowl|ceramic|ceramics-containers",
        "ao/mobile-large/DP-13440-010.jpg",
        0.99
    ),
    SearchData(
        600,
        313414,
        "Nose Ornament",
        "nose ornament|gold|metal-ornaments",
        "ao/mobile-large/vs1979_206_1239.jpg",
        1.64
    ),
    SearchData(
        1466,
        309944,
        "Female Figurine",
        "figure|gold-rich silver alloy|sculpture-sheet metal",
        "ao/mobile-large/DP-13440-023.jpg",
        0.69
    ),
    SearchData(
        1500,
        310656,
        "Hunchback Paccha",
        "paccha|wood, beads|wood-containers",
        "ao/mobile-large/vs1978_412_211.jpg",
        0.76
    ),
    SearchData(
        750,
        314625,
        "Four-Cornered Hat",
        "hat|camelid hair|textiles-costumes",
        "ao/mobile-large/HZ1983_497_8.jpg",
        1.17
    ),
    SearchData(
        600,
        314872,
        "Cutout Disk",
        "ornament|gilded copper|metal-ornaments",
        "ao/mobile-large/1987.394.34.jpg",
        1.50
    ),
    SearchData(
        1475,
        309401,
        "Single Spout Bottle with Strap Handles",
        "bottle|ceramic, pigment|ceramics-containers",
        "ao/mobile-large/66.30.18_a.jpg",
        1.29
    ),
    SearchData(
        550,
        316913,
        "Coca Bag",
        "bag|camelid hair, cotton|textiles-woven",
        "ao/mobile-large/LC-1994_35_88_TMS.jpg",
        0.66
    ),
    SearchData(
        600,
        315174,
        "Disk Ornament",
        "ornament|gilded copper|metal-ornaments",
        "ao/mobile-large/DP-16099-001.jpg",
        1.33
    ),
    SearchData(
        750,
        316988,
        "Four-Cornered Hat",
        "hat|camelid hair|textiles-costumes",
        "ao/mobile-large/HZ1994_35_168.jpg",
        1.18
    ),
    SearchData(
        750,
        316341,
        "Four-Cornered Hat",
        "hat|camelid hair|textiles-costumes",
        "ao/mobile-large/HZ1994_35_151.jpg",
        1.13
    ),
    SearchData(
        1050,
        316986,
        "Four-Cornered Hat",
        "hat|camelid hair|textiles-costumes",
        "ao/mobile-large/HZ1994_35_166.jpg",
        1.19
    ),
    SearchData(
        1475,
        314823,
        "Votive Container (Canopa)",
        "container|stone|stone-containers",
        "ao/mobile-large/vs1984_524_1.jpg",
        1.40
    ),
    SearchData(
        1350,
        315748,
        "Sling shot",
        "sling shot|silver (hammered), feathers|metal-implements",
        "ao/mobile-large/SlingShot_1987_394_668_1.jpg",
        1.11
    ),
    SearchData(
        500,
        309436,
        "Stirrup Spout Bottle with Felines",
        "bottle|ceramic, pigment|ceramics-containers",
        "ao/mobile-large/67.92.jpg",
        0.67
    ),
    SearchData(
        750,
        312244,
        "Feathered Panel",
        "panel|feathers, cotton, camelid hair|textiles-featherwork",
        "ao/mobile-large/DP-15008-019.jpg",
        2.24
    ),
    SearchData(1500, 307449, "Bag", "bag|cotton|textiles-woven", "ao/mobile-large/50407.jpg", 0.72),
    SearchData(
        1500,
        315332,
        "Lime Spoon, Bird",
        "lime spoon|copper (cast)|metal-implements",
        "ao/mobile-large/VS1987_394_287.JPG",
        0.57
    ),
    SearchData(
        1543,
        751900,
        "Votive Checkerboard Tunic",
        "tunic|camelid fiber|textiles-costumes",
        "ao/mobile-large/DP-14285-001.jpg",
        0.84
    ),
    SearchData(
        1475,
        309394,
        "Storage Jar (Aryballus)",
        "bottle|ceramic|ceramics-containers",
        "ao/mobile-large/DP-13440-012.jpg",
        1.00
    ),
    SearchData(
        250,
        308539,
        "Stirrup Spout Bottle with Sleeping Warrior",
        "bottle|ceramic, slip, pigment|ceramics-containers",
        "ao/mobile-large/64.228.33.JPG",
        0.67
    ),
    SearchData(
        1650,
        307469,
        "Knife, Figures",
        "knife|bronze|metal-implements",
        "ao/mobile-large/82.1.25_a.JPG",
        0.67
    ),
    SearchData(
        1500,
        317751,
        "Paccha",
        "paccha|ceramic, pigment|ceramics-containers",
        "ao/mobile-large/1995.481.3_b.jpg",
        1.99
    ),
    SearchData(
        750,
        314622,
        "Four-Cornered Hat",
        "hat|camelid hair|textiles-costumes",
        "ao/mobile-large/HZ1983_497_5.jpg",
        1.19
    ),
    SearchData(
        1500,
        315267,
        "Copper Lime Spoon with Bird Top",
        "lime spoon|copper (cast)|metal-implements",
        "ao/mobile-large/VS1987_394_207.jpg",
        0.44
    ),
    SearchData(
        1000,
        316431,
        "Beaker with Figure Displaying a Shell",
        "beaker|gold|metal-containers",
        "ao/mobile-large/DP215719.jpg",
        0.80
    ),
    SearchData(
        1385,
        312952,
        "Standing Male Figure",
        "male figure|wood|wood-sculpture",
        "ao/mobile-large/DP-24345-001.jpg",
        0.52
    ),
    SearchData(
        600,
        315134,
        "Profile Warrior Ornament",
        "ornament|gilded copper, shell|metal-ornaments",
        "ao/mobile-large/1987.394.71.JPG",
        0.67
    ),
    SearchData(
        1400,
        310566,
        "Copper Knife with Figure Handle",
        "knife|copper|metal-implements",
        "ao/mobile-large/1978.412.114_a.JPG",
        1.50
    ),
    SearchData(
        1500,
        315634,
        "Figure Lime Spoon",
        "lime spoon|copper|metal-implements",
        "ao/mobile-large/1987.394.585.jpg",
        0.67
    ),
    SearchData(
        1475,
        316835,
        "Paccha",
        "paccha|wood|wood-containers",
        "ao/mobile-large/1994.35.7.jpg",
        0.64
    ),
    SearchData(
        1500,
        315617,
        "Silver Pin",
        "pin|silver (hammered)|metal-ornaments",
        "ao/mobile-large/vs1987_394_557.JPG",
        0.50
    ),
    SearchData(
        1475,
        309390,
        "Miniature Vessel",
        "miniature dish|ceramic|ceramics-containers",
        "ao/mobile-large/DP-24277-001.jpg",
        1.09
    ),
    SearchData(
        1350,
        312801,
        "Plume",
        "plume|gold|metal-ornaments",
        "ao/mobile-large/rlf1979.206.605b.jpg",
        0.75
    ),
    SearchData(
        1425,
        317736,
        "Woman\"s Dress",
        "dress|camelid hair|textiles-woven",
        "ao/mobile-large/DT1275.jpg",
        1.25
    ),
    SearchData(
        1500,
        313310,
        "Single Spout Bottle",
        "bottle|ceramic|ceramics-containers",
        "ao/mobile-large/1979.206.1117.jpg",
        0.80
    ),
    SearchData(
        1475,
        309397,
        "Miniature Jar with Two Handles",
        "jar|ceramic|ceramics-containers",
        "ao/mobile-large/66.30.14.jpg",
        1.09
    ),
    SearchData(
        1500,
        315621,
        "Silver Pin",
        "pin|silver (hammered)|metal-ornaments",
        "ao/mobile-large/VS1987_394_561.JPG",
        0.37
    ),
)